import React from "react";
import { Download } from "lucide-react";

/**
 * Renders a small download button that opens the CSV endpoint with the
 * current admin token (the auth cookie is sent automatically; bearer fallback
 * uses the same `authClient` flow). Backend builds the CSV server-side.
 */
const CsvExportButton = ({ authClient, endpoint, filename, label }) => {
  const onDownload = async () => {
    try {
      const { data } = await authClient().get(endpoint, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.warn("[csv export]", err);
    }
  };
  return (
    <button
      type="button"
      onClick={onDownload}
      className="btn-secondary !px-3 !py-1.5 text-[10px] tracking-[0.16em] uppercase font-bold"
      data-testid={`csv-${endpoint.split("/").pop().replace(".csv", "")}`}
    >
      <Download size={12} className="mr-1.5" /> {label}
    </button>
  );
};

export default CsvExportButton;
